var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Sizes } from '../../types';
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var RadioButtonSizes = __assign({}, Sizes);
export var RadioButtonStates;
(function (RadioButtonStates) {
    RadioButtonStates["Disabled"] = "DISABLED";
    RadioButtonStates["Default"] = "DEFAULT";
})(RadioButtonStates || (RadioButtonStates = {}));
export var RadioButtonDesignStyles;
(function (RadioButtonDesignStyles) {
    RadioButtonDesignStyles["Standard"] = "STANDARD";
    RadioButtonDesignStyles["Rounded"] = "ROUNDED";
    RadioButtonDesignStyles["Squared"] = "SQUARED";
})(RadioButtonDesignStyles || (RadioButtonDesignStyles = {}));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var isColorButton = function (object) {
    return 'color' in object;
};
